class WishlistBuy extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  async handleTrigger (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    const items = []

    this.externalEls.form.elements.forEach((el) => {
      const submitElement = el.querySelector(
        '[data-wishlist-buy-external-el="submit"]',
      )

      if (submitElement && submitElement.disabled) return

      items.push({
        id: parseInt(el.querySelector('[name="id"]').value),
        quantity: 1,
      })
    })

    return window.BAO.Cart.addItem(items)
  }
}

if (!customElements.get('wishlist-buy')) {
  customElements.define('wishlist-buy', WishlistBuy)
}
